import { render, staticRenderFns } from "./SidebarTextArea.vue?vue&type=template&id=eb5e40f2&scoped=true&"
import script from "./SidebarTextArea.vue?vue&type=script&lang=js&"
export * from "./SidebarTextArea.vue?vue&type=script&lang=js&"
import style0 from "./SidebarTextArea.vue?vue&type=style&index=0&id=eb5e40f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5e40f2",
  null
  
)

export default component.exports